export default "__VITE_ASSET__2OzMImRz__"